<script setup lang="ts">
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmModal,
} from 'tir-components';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

/**Роутер */
const router = useRouter();

/**Параметры */
const props = defineProps({
  /**Изменения в проекте */
  isProjectSettingsChanged: { type: Boolean },
  /**Видимость модалки */
  visible: { type: Boolean },
});
/**События */
const emit = defineEmits<{
  /**Событие изменения видимости окна */
  toggleVisibleModal: [state: boolean];
  /**Подтверждение выхода */
  confirmLeave: [];
}>();

/**Переходимый путь */
const pendingRoute = ref();

/**Переключение видимости окна */
const toggle = (_visible: boolean, callback?: Function) => {
  emit('toggleVisibleModal', _visible);
};

/**Подтверждение выхода */
const confirmLeave = () => {
  emit('confirmLeave');
  toggle(false);
  router.push(pendingRoute.value);
};
/**Проверка наличия изменений в форме перед переходом */
router.beforeEach((to, from, next) => {
  if (!props.isProjectSettingsChanged) {
    pendingRoute.value = to;
    toggle(true);
  } else {
    next();
  }
});
</script>

<template>
  <TirPmModal
    class="task-parameters-leave"
    title="Выйти сейчас?"
    :is-with-back="false"
    :is-visible="visible"
    @close="toggle(false)"
  >
    <template #content>
      <span class="task-parameters-leave_content"> Если выйти сейчас, данные не сохранятся </span>
    </template>
    <template #footer>
      <TirPmButton
        :size="TirPmButtonSizeEnum.Regular"
        :variant="TirPmButtonVariantEnum.PrimaryState"
        @click="toggle(false)"
      >
        Вернуться
      </TirPmButton>
      <TirPmButton
        :size="TirPmButtonSizeEnum.Regular"
        :variant="TirPmButtonVariantEnum.LinkState"
        @click="confirmLeave"
      >
        Выйти
      </TirPmButton>
    </template>
  </TirPmModal>
</template>
